<template>
  <div class="open-order">
    <div class="header">
      <span class="title">سفارشات فعال</span>
      <div class="buttons">
        <button @click="cryptofn" class="solid-gray-btn" :class="{'gray-btn' : select === 'crypto'}">
          رمز ارز
        </button>

        <button @click="goldfn" class="solid-gray-btn" :class="{'gray-btn' : select === 'gold'}">
          طلا و سکه
        </button>
      </div>
    </div>
    <div class="main-table">
      <table>
        <tr class="sticky">
          <td>بازار</td>
          <td class="hide-under-600">زمان و تاریخ</td>
          <td class="hide-under-600">سمت</td>
          <td class="hide-under-600">نوع</td>
          <td class="hide-under-400">قیمت واحد</td>
          <td >مقدار</td>
          <td class="hide-under-400">کارمزد</td>
          <td class="hide-under-400">مبلغ کل</td>
          <td class="hide-under-400">مقدار پر شده</td>
          <td @click="cancelAll = true"
              :style="{'text-align': 'left',cursor:'pointer'}"
              class="red">لغو همه</td>
        </tr>

<template v-if="select==='gold'">
          <tr v-for="(item ,index) in dataTable[0]" :key="index">
          <td>{{ item.market }}</td>
          <td class="hide-under-600">{{ item.date }}</td>
          <td class="hide-under-600" :class="{'red' : item.side === 'فروش' , 'green' : item.side === 'خرید'}">
            {{ item.side }}
          </td>
          <td class="hide-under-600">{{ item.type }}</td>
          <td class="hide-under-400">{{ item.unitprice }}</td>
          <td>{{ item.amount }}</td>
          <td class="hide-under-400">{{ item.fee }}</td>
          <td class="hide-under-400">{{ item.wholeprice }}</td>
          <td class="hide-under-400">{{ item.value + '%'}}</td>
          <td @click="dataTable[0].splice(index,index+1)"
              :style="{'text-align': 'left','padding-left': '15px',cursor:'pointer'}"
              class="red" >لغو سفارش</td>

        </tr>
</template>

        <template v-if="select ==='crypto'">
          <tr v-for="(item ,index) in cryptoOpenOrders" :key="index">
            <td style="text-align: right">


{{ item.orderType.includes('BUY') ?  $coins[item.destinationCoin].persianName +'-'+ $coins[item.sourceCoin].persianName : $coins[item.sourceCoin].persianName +'-'+ $coins[item.destinationCoin].persianName }}

            </td>
            <td class="hide-under-600">{{ $G2J(item.createdAtDateTime) }}</td>
            <td class="hide-under-600"
                :class="{'red' : item.orderType.includes('SELL'), 'green' : item.orderType.includes('BUY') }">
              {{ item.orderType.includes('SELL') ? 'فروش' : 'خرید' }}

            </td>
            <td class="hide-under-600"
                :class="{'red' : item.orderType.includes('SELL'), 'green' : item.orderType.includes('BUY') }">
              {{ $orderType[item.orderType] }}
            </td>
            <td class="hide-under-600">{{ $toLocal(item.unitPrice, $decimal['TOMAN']) }}</td>
            <td>{{ item.amount.toLocaleString() }}</td>
            <td class="hide-768">{{ state.userInfo.fee }}</td>
            <td class="hide-under-400">{{ $toLocal(item.wholePrice, $decimal['TOMAN']) }}</td>
            <td class="hide-768">%{{ item.executedPercent.toLocaleString() }}</td>
            <td :style="{'text-align': 'left','padding-left': '15px',cursor:'pointer'}" class="red"
                v-if="select === 'crypto'">
              <span @click=showModal(item)>  لغو سفارش</span>

            </td>
            <td :class="{'red' : item.orderStatus === 'لغوشده' , 'green' : item.orderStatus ===  'تکمیل شده' , 'yellow' : item.orderStatus === 'انقضا'}"
                v-if="select === 'orderHistory'">{{ $orderStat[item.orderStatus] }}
            </td>

            <!--            <td class="number"   :class="{'red' : item.rivals < 0 , 'green' : item.rivals > 0 }" v-if="select === 'tradeHistory'">-->
            <!--              <span v-if="item.rivals > 0">+</span>-->
            <!--              {{ item.rivals }}-->
            <!--            </td>-->


          </tr>

        </template>



      </table>
    </div>
        <deleteOrder v-if="cancelModal" @close="cancelModal = false" @remove="removeorder"></deleteOrder>
    <delete-all v-if="cancelAll" @close='cancelAll = false' @remove='removeAll'/>
  </div>
</template>

<script>
import{Loop} from "@/lib/reuseableFunction";
import deleteOrder from "../../../trade/components/deleteOrder.vue";
import deleteAll from "../../../trade/components/deleteAll.vue";
export default {
  name: "open-order-table",
  components: {
    deleteOrder,
    deleteAll

  },

  data(){
    return{
      select:'crypto',
            cancelModal: false,
      cancelAll: false,
      idDeleteAll: true,
  removeid: 0,
      dataTable:[],
  loop: '',
      cryptoOpenOrders:[],
completedModal: false,

      cryptoData:[
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          innervalue:0,
          cancel: 'لغو سفارش'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'خرید',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          innervalue:0,
          cancel: 'لغو سفارش'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          innervalue:0,
          cancel: 'لغو سفارش'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'خرید',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          innervalue:0,
          cancel: 'لغو سفارش'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          innervalue:0,
          cancel: 'لغو سفارش'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'خرید',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          innervalue:0,
          cancel: 'لغو سفارش'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          innervalue:0,
          cancel: 'لغو سفارش'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'خرید',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          innervalue:0,
          cancel: 'لغو سفارش'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          innervalue:0,
          cancel: 'لغو سفارش'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          innervalue:0,
          cancel: 'لغو سفارش'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 10112456,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 100112456,
          value: 0,
          innervalue:0,
          cancel: 'لغو سفارش'
        },
      ],

      goldData:[
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 2322323,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 555548555,
          value: 5251,
          innervalue:0,
          cancel: 'لغو سفارش'
        },

        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 2322323,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 555548555,
          value: 5251,
          innervalue:0,
          cancel: 'لغو سفارش'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 2322323,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 555548555,
          value: 5251,
          innervalue:0,
          cancel: 'لغو سفارش'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 2322323,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 555548555,
          value: 5251,
          innervalue:0,
          cancel: 'لغو سفارش'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 2322323,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 555548555,
          value: 5251,
          innervalue:0,
          cancel: 'لغو سفارش'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 2322323,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 555548555,
          value: 5251,
          innervalue:0,
          cancel: 'لغو سفارش'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 2322323,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 555548555,
          value: 5251,
          innervalue:0,
          cancel: 'لغو سفارش'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 2322323,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 555548555,
          value: 5251,
          innervalue:0,
          cancel: 'لغو سفارش'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 2322323,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 555548555,
          value: 5251,
          innervalue:0,
          cancel: 'لغو سفارش'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 2322323,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 555548555,
          value: 5251,
          innervalue:0,
          cancel: 'لغو سفارش'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 2322323,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 555548555,
          value: 5251,
          innervalue:0,
          cancel: 'لغو سفارش'
        },
        {
          market: 'TMN-BTC',
          date: '00/12/03 | 14:33',
          side: 'فروش',
          type: 'حد',
          unitprice: 2322323,
          amount: '0.01',
          fee: '0 %',
          wholeprice: 555548555,
          value: 5251,
          innervalue:0,
          cancel: 'لغو سفارش'
        },
      ]
    }
  },

  methods:{
    goldfn(){
      this.dataTable = []
      this.select = 'gold';
      this.dataTable.push(this.goldData)
    },

    cryptofn(){
      this.dataTable = []
      this.select = 'crypto';
      this.dataTable.push(this.cryptoData)
    },
        showModal(e) {
      this.loop.stop()
      this.cancelModal = true
      console.log(e)
      this.removeid = e.id

    },
    async removeorder() {
      //   this.state.loading = true
      this.cancelModal = false
      const [res,] = await this.$http.delete(`orders/${this.removeid}`)
      if (res) {
        ++this.state.orderChange
        this.modalshow = false
        this.completedModal = true
        this.$error('سفارش با موفقیت حذف شد', '', 'success')
        if (this.state.loop) {
          this.loop.start()
        } else {
          this.getActiveOrders()
        }
      }
    },
        async removeAll() {
      //   this.state.loading = true
      this.cancelAll = false
      const [res,] = await this.$http.delete(`/orders/all`, {
        params: {
          marketType: this.$route.params.tradeFrom + '_' + this.$route.params.tradeTo,
        }
      })
      if (res) {
        ++this.state.orderChange
        // this.modalshow = false
        this.completedModal = true
        this.$error('سفارش با موفقیت حذف شد', '', 'success')
        if (this.state.loop) {
          this.loop.start()
        } else {
          this.getActiveOrders()
        }
      }
    },
       async getActiveOrders() {
      // this.state.loading = true
      const res = await this.$axios.get('/orders', {
        params: {
          orderStatus: 'IS_OPEN',
          // market: this.$route.params.tradeFrom + '_' + this.$route.params.tradeTo,
        }
      })
      console.log(res.content)
      this.cryptoOpenOrders = res.content;
      // console.log(this.openTable)
      this.loading = false
    },
  },


mounted(){
    this.getActiveOrders()
     if (this.state.loop) {
      this.loop = new Loop(this.getActiveOrders, 5000, 'activeOrder')
      this.loop.start()
    } else {
      this.getActiveOrders()
    }

},
  beforeDestroy() {
    this.loop.stop()
  },


  created() {
    this.dataTable.push(this.cryptoData)
  }
}
</script>

<style lang="scss" scoped>
.gray-btn {
  background: rgba(215, 200, 200, 0.12) !important;
  border-radius: 4px !important;
  color: rgba(17, 153, 250, 1) !important;
  cursor: pointer !important;
  font-size: clamp(10px, 2vw, 12px) !important;
  height: auto;
  width: auto;
}

.open-order {
  display: flex;
  flex-direction: column;
  gap: 30px;

  .header{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    color: #FFFFFF;
    flex-wrap: wrap;
    gap: 10px;
    padding: 0 20px;

    button {
      width: 104px;
      height: 25px;
      margin-left: 7px;
    }
  }

  .main-table {
    height: 400px;
    overflow: auto;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    .sticky{
      position: sticky;
      top: 0;
      background: #091222;
    }

    table {
      table-layout: fixed;
      color: #FFFFFF;

      tr{
        height: 100px;
      }

      td {
        text-align: right;
        font-size: clamp(12px, 2vw, 14px);
      }

      td {
        text-align: right;
        font-size: clamp(12px, 2vw, 14px);
        padding: 0 !important;
      }
    }
  }
}

@media (max-width: 800px) {
  .hide-768 {
    display: none !important;
  }
  .hide-under-600 {
    display: none;
  }

  .bottom-row{
    padding: 10px !important;
  }
}

@media (max-width: 550px) {
  .hide-under-400 {
    display: none;
  }

  .bottom-row{
    padding: 10px !important;
  }
}
</style>